<template>
  <div id="blablacar">
    <iframe src="//www.blablacar.fr/widget/FR_WIDGET_PSGR" style="border:0px; padding:0px;" width="180px" height="270px" frameborder="0" scrolling="no"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  }
};
</script>

<style lang="scss">
#blablacar {
  text-align: center;
  iframe {
    width: 80%;
    margin: auto;
    max-width: 500px;
  }
}
</style>
